<template>
  <div class="flex flex-col">
    <div class="flex flex-col mb-6">
      <label class="font-semibold text-sm text-grey-700 mb-2">
        {{ $t('frontend_groovemail_mail_tag_name') }}
      </label>
      <text-input
        variant="base"
        v-model="model.name"
        :validator="$v.model.name"
        :placeholder="this.$t('frontend_groovemail_adminsetting_name')"
      />
    </div>
    <div class="flex justify-end">
      <gd-button
        size="auto"
        @click="closeCreateBroadcastCatModal"
        >{{ $t('frontend_cancel') }}</gd-button
      >
      <gd-button
        class="ml-2"
        size="auto"
        variant="primary"
        @click="catId ? updateBroadcastCategory() : createBroadcastCategory()"
        >{{
          catId
            ? $t('frontend_update')
            : category
            ? $t('frontend_clone')
            : $t('frontend_save')
        }}</gd-button
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig.js';

export default {
  name: 'step1',
  props: {
    catId: {
      required: false,
      default: null,
    },
    category: {
      required: false,
      default: '',
    },
  },

  data() {
    return {
      model: {
        name: '',
      },
    };
  },

  validations: {
    model: {
      name: { required, minLength: minLength(3), maxLength: maxLength(50) },
    },
  },

  created() {
    this.model.name = this.category;
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    closeCreateBroadcastCatModal() {
      this.$emit('closeCreateBroadcastCatModal');
    },

    async createBroadcastCategory() {
      this.$v.model.name.$touch();      
      if (!this.$v.model.name.$invalid) {
        this.showLoader();

        try {
          const broadcastCat = {
            name: '',
          };
          broadcastCat.name = this.model.name;
          const customBroadcastCat = await axios.post('/add-campaign-tags', broadcastCat);
          await this.$emit('fetchBroadcastCategories');
          this.$emit('assignBroadcastCat', customBroadcastCat);
          this.model.name = '';
          this.$v.model.name.$reset();
          this.$emit('closeCreateBroadcastCatModal');

          // hide the loader
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }
    },

    async updateBroadcastCategory() {
      this.$v.model.name.$touch();

      if (!this.$v.model.name.$invalid) {
        this.showLoader();

        try {
          const broadcastCat = {
            name: '',
          };
          broadcastCat.name = this.model.name;
          await axios.put(`/campaign-tags/${this.catId}`, broadcastCat);
          await this.$emit('fetchBroadcastCategories');
          this.model.name = '';
          this.$v.model.name.$reset();
          this.$emit('closeCreateBroadcastCatModal');

          // hide the loader
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }
    },
  },
};
</script>
